import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import "../../NosMetiers.css";
import gc from "../../assets/gc.jpeg";
import TP from "../../assets/TP.jpeg";
import espace from "../../assets/espace.jpeg";

const NosMetiersPage = () => {
  const { hash } = useLocation(); 

  useEffect(() => {
    if (hash) {
      const id = hash.replace("#", ""); 
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [hash]); // Exécuter lorsque l'ancre change

  const sections = [
    {
      id: "travaux-publics", 
      title: "Travaux Publics",
      description:
        "Aménagement et entretien des voies, création d'axes routiers, aménagement de trottoirs.",
      image: TP,
      subsections: [
        {
          title: "Voirie",
          description:
            "Aménagement et entretien des voies, création d'axes routiers, aménagement de trottoirs.",
        },
        {
          title: "Réseaux",
          description:
            "Assainissement, raccordement, réseaux secs, enfouissement de réseaux.",
        },
        {
          title: "Terrassement",
          description: "Nivellement, fondations, drainage.",
        },
      ],
    },
    {
      id: "genie-civil",
      title: "Génie Civil",
      description:
        "Notre expertise technique au service des ouvrages d'art et des structures complexes.",
      image: gc,
      subsections: [
        {
          title: "Structure",
          description:
            "Réhabilitation, renforcement structural, fondations spéciales.",
        },
        {
          title: "Infrastructure",
          description: "Stations de pompage, ouvrages hydrauliques, bassins techniques.",
        },
        {
          title: "Ouvrages d'Art",
          description: "Ponts, passerelles, Murs de soutènement, bassins de rétention.",
        },
      ],
    },
    {
      id: "espace", // ID unique pour chaque section
      title: "Espace Verts - Aménagement Extérieur",
      description:
        "Création d'espaces verts urbains et périurbains pour un cadre de vie agréable et durable.",
      image: espace,
      subsections: [
        {
          title: "Aménagement Paysager",
          description:
            "Création d'espaces verts, systèmes d'irrigation, mobilier urbain.",
        },
        {
          title: "Surfaces",
          description: "Aires de jeux, parkings, chemins piétonniers.",
        },
        {
          title: "Aménagement Urbain",
          description:
            "Places et parvis, squares urbains, jardins publics.",
        },
      ],
    },
  ];

  return (
    <div className="nos-metiers">
      {sections.map((section, index) => (
        <div key={index} id={section.id} className="metier-section"> {/* Ajout de l'ID pour permettre le ciblage */}
          <div className="section-header">
            <h2>{section.title}</h2>
            <p>{section.description}</p>
          </div>
          <div className="section-content">
            <img src={section.image} alt={section.title} className="section-image" />
            <div className="subsections">
              {section.subsections.map((subsection, subIndex) => (
                <div key={subIndex} className="subsection">
                  <h3>{subsection.title}</h3>
                  <p>{subsection.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default NosMetiersPage;
